<style lang="stylus">
    .AddLibrary-mask
        modal-mask()
        .AddLibrary-modal
            //width 360px
            .AddLibrary-container
                padding-bottom: 24px
                .AddLibrary-line
                    display flex
                    justify-content space-between
                    >p
                        line-height 32px
</style>

<template>
    <div class="AddLibrary-mask">
        <Dialog class="AddLibrary-modal" :title="$t('addLibrary')" :isShow="true" @close="closeModal">
            <div class="AddLibrary-container">
                <div class="AddLibrary-line">
                    <p>{{ $t("libraryName") }}:</p>
                    <Input v-model="tableName" style="width: 260px; margin-left: 10px" />
                </div>
            </div>
            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";
    import appConfig from "@/public/globalConfig";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class AddLibrary extends Vue {
        @Inject()
        ["showMessage"];
        tableName: string = "";
        DbName: string = "userDB";
        userWorkerURL: string = appConfig.userWorkerURL;
        worker: any;

        get showUpgradeVal() {
            return this.$store.state.publicStore.showUpgrade;
        }
        showCloudSpaceLimit() {
            if (!this.vip && this.showUpgradeVal != "cloudSpace") {
                this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
            } else if (this.vip && this.showUpgradeVal != "cloudSpaceVIP") {
                if (this.fuser) {
                    this.$bus.$emit("showCloudSpaceVipTips");
                } else {
                    this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                }
            }
        }
        confirm() {
            if (this.tableName == "") {
                this.closeModal();
                this.showMessage({
                    type: 2,
                    imgType: 2,
                    time: 1,
                    content: this.$t("nullName"),
                });
                return;
            }
            let repeatedRemind = {
                // 放在worker里不能使用$t翻译
                type: 2,
                imgType: 2,
                time: 1,
                content: this.$t("repeatedName"),
            };
            if (this.tableName === this.$t("collectSymbol")) {
                this.closeModal();
                this.showMessage(repeatedRemind);
                return;
            }
            let userInfo = this.$store.state.user.userInfo;
            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "new",
                urls: this.urls,
                data: {
                    DBName: this.DbName,
                    tableName: this.tableName,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                    userInfo: {
                        id: userInfo.user_id,
                        token: userInfo.token,
                    },
                    libType: 0,
                },
            });
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "newOK") {
                    this.worker.terminate();
                    let ts: any = this;
                    uploadStoreInfo(message.children);
                    ts.$bus.$asyncEmit("uploadToCloud", { message });
                    // window['_view'].saveLib(this.DbName, this.tableName).then((files) => {
                    //     let fileSize = files[0].file.size + files[1].file.size;
                    //     this.$store.dispatch('upLoadLibrary', {
                    //         param: {
                    //             id: userInfo.user_id,
                    //             token: userInfo.token,
                    //             targetUrl: 'customlib'
                    //         },
                    //         size: fileSize,
                    //         files: files,
                    //         tableName: this.tableName,
                    //         version: message.data.version,
                    //         tableID: message.data.tableID,
                    //     }).then(e => {
                    //         this.$edApi.getCustomLibraryList({id: userInfo.user_id,token: userInfo.token}).then(e => {
                    //             this.$store.commit('setLibraryState', {
                    //                 type: 'ossList',
                    //                 data: e.data
                    //             })
                    //             this.uploadStoreInfo(message.children);
                    //             console.log(e.data)
                    //             console.log('new library upload ok')
                    //         })
                    //     })
                    // })
                } else if (message.data && message.data.msg === "name repeat") {
                    this.showMessage(repeatedRemind);
                } else if (message.data && message.data.msg == "storage space not enough") {
                    this.showCloudSpaceLimit();
                }
            };
            this.closeModal();
            let ts = this;
            let uploadStoreInfo = (tableArr) => {
                // create table
                let menu = JSON.parse(JSON.stringify(ts.$store.state.library.menuList));
                let checkbox = JSON.parse(JSON.stringify(ts.$store.state.library.checkbox));

                checkbox[ts.DbName].push(tableArr[0].id); // 更新选中数据
                // this.$store.state.library.checkbox = checkbox

                for (let i = 0; i < menu.length; i++) {
                    // 更新用户自定义库的表名
                    if (menu[i].groupName == ts.DbName) {
                        menu[i].children = menu[i].children.concat(tableArr);
                    }
                }

                ts.$store.commit("setLibraryState", {
                    type: "checkbox",
                    data: checkbox,
                });
                ts.$store.commit("setLibraryState", {
                    type: "menuList",
                    data: menu,
                });
                ts.$store.commit("setStatus", {
                    type: "selectLibrary",
                    data: [ts.DbName, ts.tableName, tableArr[0].id],
                });
            };
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {}

        created() {
            this.DbName = this.$store.state.library.extraDB[2];
        }
    }
</script>
<i18n>
{
  "zh": {
    "addLibrary": "新增库",
    "collectSymbol": "我的收藏",
    "libraryName": "库名",
    "confirm": "确定",
    "cancel": "取消",
    "nullName": "库名不可为空",
    "repeatedName": "库名不可重复"
  },
  "en": {
    "addLibrary": "New Library",
    "collectSymbol": "My Collect",
    "libraryName": "Library Name",
    "confirm": "OK",
    "cancel": "Cancel",
    "nullName": "Library Name cannot be empty.",
    "repeatedName": "Library Name cannot be repeated."
  },
  "fr": {
    "addLibrary": "Ajouter Bibliothèque",
    "collectSymbol": "Ma collection",
    "libraryName": "Nom de Bibliothèque",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "nullName": "Nom de bibliothèque ne peut pas être vide",
    "repeatedName": "Nom de bibliothèque ne peut pas être dupliqué"
  },
  "de": {
    "addLibrary": "Neue Bibliothek",
    "collectSymbol": "Meine Sammlung",
    "libraryName": "Bibliotheksname",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "nullName": "Bibliotheksname darf nicht leer sein",
    "repeatedName": "Bibliotheksname kann nicht wiederholt werden"
  },
  "jp": {
    "addLibrary": "ライブラリを追加",
    "collectSymbol": "お気に入り",
    "libraryName": "ライブラリ名",
    "confirm": "OK",
    "cancel": "キャンセル",
    "nullName": "ライブラリ名は空にできません",
    "repeatedName": "ライブラリ名は重複できません"
  },
  "es": {
    "addLibrary": "Nueva Biblioteca",
    "collectSymbol": "Mi colección",
    "libraryName": "Nombre de la biblioteca",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "nullName": "Nombre de la biblioteca no puede estar vacío",
    "repeatedName": "El nombre de la biblioteca no puede ser repetido"
  },
  "pt": {
    "addLibrary": "Nova Biblioteca",
    "collectSymbol": "Minha Coleção",
    "libraryName": "Nome da Biblioteca",
    "confirm": "OK",
    "cancel": "Cancelar",
    "nullName": "O Nome da Biblioteca não pode estar vazio.",
    "repeatedName": "Nome de Biblioteca não pode ser repetido."
  },
  "it": {
    "addLibrary": "Nuova Libreria",
    "collectSymbol": "La Mia Raccolta",
    "libraryName": "Nome Libreria",
    "confirm": "OK",
    "cancel": "Annulla",
    "nullName": "Si prega di selezionare un nome per la libreria.",
    "repeatedName": "Il nome selezionato è già esistente. Si prega di sceglierne un altro."
  },
  "tw": {
    "addLibrary": "新增庫",
    "collectSymbol": "我的收藏",
    "libraryName": "庫名",
    "confirm": "確定",
    "cancel": "取消",
    "nullName": "庫名不可為空",
    "repeatedName": "庫名不可重複"
  },
  "kr": {
    "addLibrary": "새 라이브러리",
    "collectSymbol": "내 즐겨찾기",
    "libraryName": "라이브러리 이름",
    "confirm": "확인 ",
    "cancel": "취소",
    "nullName": "라이브러리 이름은 비워 둘 수 없습니다.",
    "repeatedName": "라이브러리 이름을 반복할 수 없습니다."
  }
}
</i18n>
